import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { LogoOriginal } from "../_components/Imagepath";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import SupportButtonHeader from "./common/SupportButtonHeader";
import PropTypes from "prop-types";

import { useAuth } from "../context/AuthContext";

import AddressRegistration from "./common/AddressRegistration";


import UploadImage from "./UploadImage";

import { schema } from "../schema/schemaRegisterAgencyAdmin";

import InvitedEmailField from "./common/InvitedEmailField";
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
import ReCAPTCHA from "react-google-recaptcha";

const RegisterAgencyAdmin = (props) => {
  const recaptcha = useRef();
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  useEffect(() => {
   
    if (user?.token) {

      history.push('/dashboard')
    }
  }, [user]);

  RegisterAgencyAdmin.propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };
  const url = window.location.href;

  const tokenMatch = url.match(/token=([^&]+)/);

  const token = tokenMatch ? tokenMatch[1] : null;

  const { history } = props;
  const inputValues = {

    companyname: "",
    employment_registration: "",
    registration_number: "",


    name: "",
    email: "",

    password1: "",
    password2: "",

    phone: "",


    street: "",
    postal_code: null,

    recaptcha: "",


    token: token,
  };


  const { reset, handleSubmit, setError, setValue, clearErrors, register, formState: { errors } } = useForm({
    resolver: yupResolver(schema(t)),
    defaultValues: inputValues,
  });
  useEffect(() => {
    reset(inputValues);
  }, [reset]);

  const auth = useAuth();

  const handleFileChange = (file) => {
    setValue('imgprofile', file, { shouldValidate: true });
  };

  const onSubmit = async (data) => {
    const recaptchaValue = recaptcha.current?.getValue();
    if (!recaptchaValue) {
      setError("root", {
        type: "server",
        message: "Please verify that you are not a robot"
      });
      return;
    }

    clearErrors(); // Clears all errors


    auth.register("agency-admin", data, (error) => {
      if (!error) {
        //if (token) {
         // history.push("/dashboard"); // Redirect on success
        //} else {
          history.push("/verification-notifications"); // Redirect on succes
          logout()
       // }
      } else {
        console.log("error")

             recaptcha.current.reset();



        let errorMessage = false; // Initialize the error message variable

        if (error?.response?.data?.token) {
          errorMessage = `Token ${error.response.data.token} or email is not valid.`;
          setError("root", { type: "server", message: errorMessage });
          return
        }



        // Handle other errors dynamically
        if (error?.response?.data) {
          errorMessage = ""
          Object.entries(error.response.data).forEach(([key, values]) => {

            
            //errorMessage += `${key} : ${values}\n`;
            errorMessage += `${values}\n`;


          });
        }

        // If no specific error was found, provide a default message
        if (!errorMessage) {

          errorMessage = "An unknown error occurred.";
        }

        // Set the error message in React Hook Form
        setError("root", { type: "server", message: errorMessage });

      }
    });


  };


  return (
    <div className="main-wrapper  login-body">
      <div className="login-wrapper">
        <div className="container">
          <img
            className="img-fluid logo-dark mb-2"
            src={LogoOriginal}
            alt="Logo"
          />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>{t("Register")}</h1>
                <p className="account-subtitle">{t("Access to our dashboard")}</p>

                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">

                 




                  {/* Company Info*/}


                  <div className="separator my-4">
                    <span>{t("COMPANY INFO")}</span>
                  </div>


                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Company Name")}</label>
                    <input className="form-control" type="text" {...register("companyname")} />
                    <p className="text-danger">{errors.companyname?.message}</p>
                  </div>

                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Company Registration Number")}</label>
                    <input className="form-control" type="text" {...register("registration_number")} />
                    <p className="text-danger">{errors.registration_number?.message}</p>
                  </div>
                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Employment Agency Registration")}</label>
                    <input className="form-control" type="text" {...register("employment_registration")} />
                    <p className="text-danger">{errors.employment_registration?.message}</p>
                  </div>


                  {/** Address section */}
                  <AddressRegistration register={register} errors={errors} setValue={setValue} />
                  {/** END Address section */}



                  <UploadImage register={register} errors={errors} onFileChange={handleFileChange} setValue={setValue} />


  {/* USER Info*/}


                  <div className="separator my-4">
                    <span>{t("USER INFO")}</span>
                  </div>
 <div className="input-block mb-3">
                    <label className="form-control-label">{t("Name")}</label>
                    <input className="form-control" type="text" {...register("name")} />
                    <p className="text-danger">{errors.name?.message}</p>
                  </div>
                 
  {/** InvitedEmailField section */}
                <InvitedEmailField token={token}  register={register} setError={setError} setValue={setValue}errors={errors}/>
  {/** end InvitedEmailField section */}
  
                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Contact Number")}</label>
                    <input
                      className="form-control"
                      type="tel"
                    
                      {...register("phone")}
                    />
                    <p className="text-danger">{errors.phone?.message}</p>
                  </div>



                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Password")}</label>
                    <input className="form-control" type="password" {...register("password1")} />
                    <p className="text-danger">{errors.password1?.message}</p>
                  </div>
                  <div className="input-block mb-3">
                    <label className="form-control-label">{t("Confirm Password")}</label>
                    <input className="form-control" type="password" {...register("password2")} />
                    <p className="text-danger">{errors.password2?.message}</p>
                  </div>
                  
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    ref={recaptcha}
                    className="mb-2"
                    onChange={(value) => {
                      setValue("recaptcha", value);
                      if (value) {
                        clearErrors("recaptcha");
                      }
                    }}
                    onExpired={() => {
                      setValue("recaptcha", "");
                      setError("recaptcha", {
                        type: "manual",
                        message: t("ReCAPTCHA has expired, please verify again")
                      });
                    }}
                  />
                  {errors.recaptcha && (
                    <p className="text-danger">{errors.recaptcha.message}</p>
                  )}


                  <div className="input-block mt-5">
                    <button type="submit" className="btn btn-lg btn-block btn-primary w-100">
                      {t("Register as Agency")}
                      {auth.credLoading && <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i>}

                    </button>
                    <small style={{ color: "red" }}> {errors.root && <p>{errors.root.message}</p>}</small>
                  </div>
                </form>
                {/* /Form */}

                <div className="login-or">
                  <span className="or-line"></span>
                  <span className="span-or">{t("OR")}</span>
                </div>

                <div className="text-center dont-have">
                 {t("Already have an account?")} <Link to="/login">{t("Login")}</Link>
                </div>
              </div>
            </div>
          </div>
         <div className="lang-menu">
                <ul className="nav nav-tabs user-menu">
                           <SupportButtonHeader/>
                  <div className="lang-item ">
      <Lang />
      </div>
                </ul>

              </div>
        </div>
      </div>
    </div>
  );
};
export default RegisterAgencyAdmin;
